/* istanbul ignore file */

import 'telstra-ui/resources/telstraui.css';
import 'telstra-ui/resources/themes/pacific.css';
import { IApplicationDefinition } from '@apps-config/app-definition';
import { Application as BillingApplication } from '@applications/billing';
import { TReducers, billingReducer } from '@telstra-connect/billing/reducers';
import global from './global';
import { enableLogging } from '@utils/logger';
enableLogging();

const getApplication = (): IApplicationDefinition => BillingApplication;

const getReducer = (): TReducers => billingReducer;
global.TCONN = { ...global.TCONN };
global.TCONN.Billing = {
    GetApplication: getApplication,
    GetReducers: getReducer
};
